import styles from "../../../../propertydetails.module.css";
import { TextField } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import NumberFormat from "react-number-format";

function MoneyFieldTwo(props) {
    return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={2} {...props} />);
}

const schema = yup.object().shape({
    nsf_fee: yup.string().required("This field is Required").test("max-4-digit", "Amount can not be more than 6 digits.", (value) => { return parseFloat(value?.replace(/,/g, "")) < 10000; })
});

const NSFFeeSettings = ({ setLoading, property_id, nsf_fee, onUpdate }) => {
    const { getAccessTokenSilently } = useAuth0();

    const { handleSubmit, control, errors, setValue } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema),
        defaultValues: {
            nsf_fee: "",
        },
    });

    useEffect(() => {
        if (nsf_fee) {
            setValue("nsf_fee", nsf_fee);
        }
    }, [nsf_fee, setValue]);

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        if (data?.fee_amount) {
            data = { ...data, fee_amount: data?.fee_amount?.replace(/[,%]/g, "") };
        }
        return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/update-nsf-fee-settings", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            onUpdate(response.data);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ maxWidth: "300px" }}>
            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`nsf_fee`}
                        control={control}
                        render={(field) => (<MoneyFieldTwo
                            onChange={(e) => field.onChange(e)}
                            id="outlined-basic"
                            variant="outlined"
                            label={"Amount*"}
                            value={field?.value}
                            fixedDecimalScale
                        />)}
                    />
                    {errors.nsf_fee && (<p className={`${styles.ErrorM}`}>{errors.nsf_fee.message}</p>)}
                </div>
            </div>

            <div className={`${styles.ButtonDiv}`}>
                <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>
            </div>
        </div>
    </form>)
}

export default NSFFeeSettings;